import { Seo } from "../components/Seo";

export default function NotFound() {
  return (
    <div>
      {" "}
      <Seo
        title="Página no encontrada | Hípica Madrid Campogrande"
        description="La página que buscas no existe. Vuelve al inicio para descubrir nuestros servicios de equitación."
        path="/404"
        noindex
      />
      <h1 style={{ padding: 40 }}>404 - Página no encontrada</h1>
    </div>
  );
}
